module.exports = __webpack_public_path__ + "img/QrCodeScan.d128c0a8.jpg";